<div class="grid-container text-white text-weight-600">
  <div class="card">
    <span class="text-size-16">NOMBRE AGENTE</span>
    <sit-icon
      [icon]="Icon.agents_green"
      alt="gorra agente"
      class="mt-05 mb-05"
      [sizeClass]="'icon-size-64'"
    ></sit-icon>
    <span class="text-size-16">{{ properties?.name }}</span>
  </div>
  <div class="card">
    <span class="text-size-16">ÚLTIMA LECTURA</span>
    <sit-icon
      [icon]="Icon.last_hours_green"
      alt="reloj"
      class="mt-05 mb-05"
      [sizeClass]="'icon-size-64'"
    ></sit-icon>
    <span class="text-size-16">{{
      properties?.updatedDate | date: 'dd/MM/yyyy - HH:mm'
    }}</span>
  </div>
</div>
